var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11396_138574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6806 13.2274C19.8116 10.9355 17.5974 9.30566 15.0038 9.30566C12.4102 9.30566 10.196 10.9336 9.32701 13.2255C7.701 13.6524 6.5 15.1323 6.5 16.8949C6.5 18.9915 8.1981 20.6896 10.2927 20.6896H19.7073C21.8019 20.6896 23.5 18.9915 23.5 16.8949C23.5 15.1361 22.3028 13.6562 20.6806 13.2274ZM21.3693 18.5589C21.1516 18.7779 20.8926 18.9515 20.6073 19.0698C20.322 19.188 20.0161 19.2484 19.7073 19.2476H10.2927C9.66473 19.2476 9.07467 19.0029 8.63069 18.5589C8.41166 18.3408 8.23802 18.0815 8.1198 17.7959C8.00159 17.5103 7.94114 17.2041 7.94196 16.8949C7.94196 16.3637 8.11462 15.8647 8.43906 15.4473C8.75678 15.0429 9.19669 14.7521 9.69319 14.6182L10.4123 14.4303L10.676 13.7359C10.8392 13.3033 11.0669 12.8992 11.3533 12.533C11.6362 12.1701 11.9712 11.851 12.3475 11.5862C13.1273 11.0379 14.0456 10.7476 15.0038 10.7476C15.9619 10.7476 16.8802 11.0379 17.66 11.5862C18.0376 11.8519 18.3715 12.1706 18.6542 12.533C18.9407 12.8992 19.1684 13.3052 19.3316 13.7359L19.5934 14.4284L20.3106 14.6182C21.3408 14.8933 22.058 15.8287 22.058 16.8949C22.058 17.523 21.8133 18.1149 21.3693 18.5589Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11396_138574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.f67523823d319980c0a48013612c9995.svg";
export { ForwardRef as ReactComponent };